import * as Yup from 'yup';
import { FUND_INVESTMENTS_FORM_LABELS } from 'pages/FundInvestments/common/constants';

export const FUND_INVESTMENT_FORM_SCHEMA = Yup.object({
  name: Yup.string()
    .label(FUND_INVESTMENTS_FORM_LABELS.name)
    .min(3, 'Must be at least 3 characters')
    .max(255, 'Must be at most 255 characters')
    .required('Is required'),

  legal_company_name: Yup.string()
    .label(FUND_INVESTMENTS_FORM_LABELS.legal_company_name)
    .min(3, 'Must be at least 3 characters')
    .max(255, 'Must be at most 255 characters')
    .notRequired()
    .transform((_, originalValue) => (originalValue === '' ? null : originalValue)),

  website: Yup.string()
    .label(FUND_INVESTMENTS_FORM_LABELS.website)
    .url('Must be a valid URL')
    .notRequired()
    .nullable()
    .transform((_, originalValue) => (originalValue === '' ? null : originalValue)),

  captable_currency: Yup.string()
    .label(FUND_INVESTMENTS_FORM_LABELS.captable_currency)
    .max(3, 'Must be a valid 3-letter currency code')
    .required('Is required'),

  fiscal_year_end: Yup.object({
    end_month: Yup.number()
      .min(1, `${FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end_month} must be between 1 and 12`)
      .max(12, `${FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end_month} must be between 1 and 12`)
      .required(`${FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end_month} is required`),

    end_day: Yup.number()
      .min(1, `${FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end_day} must be between 1 and 31`)
      .max(31, `${FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end_day} must be between 1 and 31`)
      .required(`${FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end_day} is required`),
  })
    .label(FUND_INVESTMENTS_FORM_LABELS.fiscal_year_end)
    .required('Is required'),

  vintage_year: Yup.number()
    .label(FUND_INVESTMENTS_FORM_LABELS.vintage_year)
    .typeError('Must be a valid 4-digit year')
    .integer('Must be a whole number')
    .notRequired()
    .nullable()
    .transform((_, originalValue) => (originalValue === '' ? null : Number(originalValue))), // If the value is empty or null, return null
});
